import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPersonWithHandler } from '../../../global/ducks/person-prc-api';
import { AuthenticatedState } from '../../../global/models/authenticated-model';
import { DemographicAppKeys } from '../../../global/models/demographics-model';
import { BaseAppState } from '../../../global/models/redux-state';
import { TcsmStates } from '../../../root/tcsm-model';
import { EmploymentState } from '../../arc/features/employment/employment-model';
import { PersonalInfoState } from '../features/personal-info/personal-info-models';
import { dispatchSetCurrentPerson, dispatchSetCurrentPersonFailed } from '../features/personal-info/personal-info-slice';

export function useDemographicsPerson(app: DemographicAppKeys) {
	const authenticatedState = useSelector<BaseAppState, AuthenticatedState>(state => state.authenticatedState);
	const personState = useSelector<TcsmStates, PersonalInfoState>(state => state.personalInfo[app]);
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
	const dispatch = useDispatch();

    const clientId = app === DemographicAppKeys.myCPG ? authenticatedState?.clientGuid : employmentState?.currentEmployee?.guid;


	useEffect(() => {
		if (!personState.currentPerson && clientId) {
            dispatch(setPersonWithHandler(clientId, dispatchSetCurrentPerson(dispatch, app), () => dispatchSetCurrentPersonFailed(dispatch, app)(true)));
		}
    }, [personState.currentPerson, clientId]);

	if (!clientId || !personState || !authenticatedState?.accessToken) return false;

	return !!personState.currentPerson;
}